import theme from "../../../js/shared/new-theme";

export const defaultStyle = (hasError, hasShadow) => {
	const palette = theme.palette;
	return `
	i {
		color: ${hasError ? palette.red[500].value : palette.gray[600].value};
	}

	label {
		color: ${palette.gray[600].value};
	}

	select {
		background-color: ${theme.palette.common.white};
		border-color: ${hasError ? palette.red[500].value : palette.gray[400].value};
		color: ${hasError ? palette.red[500].value : palette.gray[600].value};
		font-weight: 500;
		box-shadow: ${hasShadow ? `4px 4px 0 ${palette.gray[1000].value}` : "none"};
		
		&:disabled + i {
			color: ${palette.gray[400].value};
		}
		&:disabled {
			background-color: ${palette.gray[100].value};
    		color: ${palette.gray[400].value};
		}
	}
`;
};
